import React, { ReactElement, useEffect } from 'react';

import buddyLogo from './../../assets/images/logo_white background.svg';
import splashImage from './../../assets/images/splash.svg';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import {
  setStoreCode,
  getStoreCode,
  getAccessToken,
  setStoreInformation,
  setUserType,
} from '../../core/localstorage-data';
import {
  fetchStoreInformation,
  storeInformation,
} from '../../redux/storeInformationSlice';
import {
  LANDING_PATH,
  SPLASH_PATH,
} from '../../routes/route-constants';
import { setPageName } from '../../lib/tagmanager';
import { pageName } from '../../lib/constants';

const Landing = (): ReactElement => {
  const navigate = useHistory();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const store_input_code = query.get('id');

  useEffect(() => {
    setPageName(pageName.splashScreen);
    const userTypeData = 'customer';
    setUserType(userTypeData);

    //getting in url
    if (store_input_code) {
      setStoreCode(store_input_code);
      navigate.replace(SPLASH_PATH);
    } else {
      navigate.replace(LANDING_PATH);
    }
  }, []);

  return (
    <div className="flex backdrop-filter bg-black opacity-75 absolute z-50 top-0 left-0 right-0 bottom-0">
      <div className="self-center flex-1">
        <svg className="animate-spin h-7 w-7 mx-auto" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="white"
            strokeWidth="4"></circle>
          <path
            className="opacity-75"
            fill="white"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
    </div>
  );
};

export default Landing;
